'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.GameMediatorId = exports.GameVendor = void 0;
var GameVendor;
(function (GameVendor) {
    GameVendor["NETENT"] = "Netent";
    GameVendor["EVOLUTION"] = "Evolution";
    GameVendor["PLAY_N_GO"] = "Play N Go";
    GameVendor["YGGDRASIL"] = "Yggdrasil";
    GameVendor["BETSOFT"] = "BetSoft";
    GameVendor["IGT"] = "IGT";
    GameVendor["NYX_GAMING"] = "NYX Gaming";
    GameVendor["SG_WMS"] = "SG Wms";
    GameVendor["QUICKSPIN"] = "Quickspin";
    GameVendor["MICROGAMING"] = "Microgaming";
    GameVendor["RED_TIGER"] = "Red Tiger";
    GameVendor["GREEN_TUBE"] = "Green Tube";
    GameVendor["SCIENTIFIC_GAMES"] = "Scientific Games";
    GameVendor["REEL54"] = "Reel54";
    GameVendor["GENII"] = "Genii";
    GameVendor["EDICT"] = "Edict";
    GameVendor["SPIGO"] = "Spigo";
    GameVendor["ELK"] = "Elk";
    GameVendor["BIG_TIME_GAMING"] = "Big Time Gaming";
    GameVendor["PRAGMATIC_PLAY"] = "Pragmatic Play";
    GameVendor["THUNDERKICK"] = "Thunderkick";
    GameVendor["PUSH_GAMING"] = "Push Gaming";
    GameVendor["PARIPLAY"] = "Pariplay";
    GameVendor["SPIN"] = "Spin";
    GameVendor["SLINGO"] = "Slingo";
    GameVendor["SOFTWEAVE_WINAFAR"] = "Softweave Winafar";
    GameVendor["AUTHENTIC_GAMES"] = "Authentic Games";
    GameVendor["NO_LIMIT_CITY"] = "Nolimit City";
    GameVendor["GIG_GAMES"] = "GiG Games";
    GameVendor["EVERI"] = "Everi";
    GameVendor["ISOFTBET"] = "iSoftBet";
    GameVendor["RELAX_GAMING"] = "Relax Gaming";
    GameVendor["ORYX_GAMING"] = "Oryx Gaming";
    GameVendor["BLUEPRINT"] = "Blueprint";
    GameVendor["BOOMING_GAMES"] = "Booming games";
})(GameVendor = exports.GameVendor || (exports.GameVendor = {}));
var GameMediatorId;
(function (GameMediatorId) {
    GameMediatorId["BOOMING_GAMES"] = "endeavour-booming-games";
    GameMediatorId["RELAX_GAMING"] = "endeavour-relax-gaming";
})(GameMediatorId = exports.GameMediatorId || (exports.GameMediatorId = {}));
